module.exports = __webpack_public_path__ + "static/media/maven-logo-2.63a7f237.png";